import pathfinder from '@fiverr-private/pathfinder';
import { PATHFINDER } from '../constants';
import type { MapperItemConfig } from './types';

export const getLandingPagePath = ({ slug }: MapperItemConfig) => {
    const params: Record<string, any> = { page_name: slug };

    return pathfinder(PATHFINDER.LANDING_PAGE, params);
};
